module.exports = __webpack_public_path__ + "img/heart-pink.6b9876be.svg";